import { useMemo } from "react";
import { useKeyboardShortcuts } from "../core/useKeyboardShortcuts";
import { ShortcutMap } from "../core/types";

interface UseTypographyShortcutsProps {
  onTypographyAdjustment: (propertyType: string, delta: number) => void;
}

export const useTypographyShortcuts = ({
  onTypographyAdjustment,
}: UseTypographyShortcutsProps) => {
  const shortcuts: ShortcutMap = useMemo(
    () => ({
      "shift+mod+,": {
        handler: () => onTypographyAdjustment("fontSize", -0.25),
        description: "Decrease font size",
      },
      "shift+mod+.": {
        handler: () => onTypographyAdjustment("fontSize", 0.25),
        description: "Increase font size",
      },
      "mod+alt+,": {
        handler: () => onTypographyAdjustment("fontWeight", -100),
        description: "Decrease font weight",
      },
      "mod+alt+.": {
        handler: () => onTypographyAdjustment("fontWeight", 100),
        description: "Increase font weight",
      },
      "alt+,": {
        handler: () => onTypographyAdjustment("letterSpacing", -0.05),
        description: "Decrease letter spacing",
      },
      "alt+.": {
        handler: () => onTypographyAdjustment("letterSpacing", 0.05),
        description: "Increase letter spacing",
      },
      "shift+alt+,": {
        handler: () => onTypographyAdjustment("lineHeight", -0.25),
        description: "Decrease line height",
      },
      "shift+alt+.": {
        handler: () => onTypographyAdjustment("lineHeight", 0.25),
        description: "Increase line height",
      },
    }),
    [onTypographyAdjustment],
  );

  useKeyboardShortcuts({ shortcuts });
};
